export default __webpack_public_path__ + "static/media/at-sign.cc9629ed.svg";